import { Alert } from 'antd';
import type { AlertProps } from 'antd';

export interface DAlertProps extends AlertProps {}

export const DarwinAlert = (props: DAlertProps) => {
  return <Alert {...props} />;
};
